var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicElementComponent,{tag:"component",attrs:{"editorMode":_vm.editorMode,"element":_vm.element,"closePopup":_vm.closePopup}})
}
var staticRenderFns = []

export { render, staticRenderFns }